var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCbd = function SvgCbd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    viewBox: "-0.1 0 16.1 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.73 4.044a6.039 6.039 0 1 0 8.54 8.54 6.039 6.039 0 0 0-8.54-8.54zm9.927-1.387A8 8 0 1 0 2.343 13.97 8 8 0 0 0 13.657 2.657z"
  })));
};
export default SvgCbd;